import { useTranslation } from 'react-i18next';
import styles from './app-evaluation-start.module.scss';

export type MissingLineProps = { items: string[]; lead?: 'send' | 'continue' };

const MissingLine = ({ items, lead = 'send' }: MissingLineProps) => {
  const [t] = useTranslation('evaluations');
  if (!items.length) return null;
  const list = items.join(', ');
  return (
    <p className={styles.hint}>
      {lead === 'continue'
        ? t('wizard.missingLead', 'För att fortsätta: {{list}}.', { list })
        : t('quick.missingLead', 'För att skicka: {{list}}.', { list })}
    </p>
  );
};

export default MissingLine;
